export default {
  budgetDistribution: "Budget's Distribution",
  cancel: "cancel",
  dateCreated: "Date Created",
  description: "description",
  dueDate: "Due Date",
  gbpt: "Global budget per type",
  location: "Location",
  name: "Name",
  newWork: "New Work",
  orderId: "Order Id",
  save: "save",
  search: "Search",
  whoReceive: "Who Receive?",
  whoSent: "Who Sent?",
  worksModule: "WPC",
  modulesbtn: "Modules"
};
